/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { kioskAuthButtonTypeEnumSchema } from "./kioskAuthButtonTypeEnumSchema.ts";

export const newKioskAuthOptionButtonSchema = z
	.object({
		auth_type: kioskAuthButtonTypeEnumSchema.describe(
			"* `card` - Физическая карта лояльности\n* `scanner` - Сканирование QR сканером штрихкодов\n* `camera` - Сканирование QR камерой устройства\n* `phone` - По номеру телефона",
		),
		main_text: z.string(),
		extra_text: z.string().nullable(),
		image: z.string().nullable(),
		order: z.int(),
	})
	.describe("Сериализатор кнопки способа авторизации на киоске.");
